import { showNotification } from "@/utils/index";

export const useCopyText = (text: string, notifyText: string = 'Ссылка скопирована', notifyType: 'success' | 'info' | 'error' = 'success'): void => {
    if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
            showNotification(notifyText, notifyType);
        });
    } else {
        unsecuredCopyToClipboard(text, notifyText, notifyType);
    }
};

const unsecuredCopyToClipboard = (text, notifyText, notifyType) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        document.execCommand('copy');
        showNotification(notifyText, notifyType);
    } catch (err) {
        console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
};
